<template>
  <div class="msg-classify-manager-view">
    <div class="main-content">
      <div class="app-main-inner-row" style="padding-top: 10px;">
        <div class="triggers">
          <span>{{ $t('CargoMsg.Cargo_Search') }}</span>
          <el-input
            v-model="keyword"
            :placeholder="$t('common.tips.fuzzySearch')"
            style="width:200px;margin: 0 10px"
            @input="fastSearchHandle()"
          />
          <el-button type="primary" @click="btnAdd">{{ $t('common.btn.new') }}</el-button>
          <el-button type="primary" @click="btnEdit">{{ $t('common.btn.edit') }}</el-button>
          <el-button size="mini" type="danger" @click="btnRemoveHandler">{{ $t('common.btn.delete') }}</el-button>
        </div>
      </div>
      <div class="section grid-wrapper" style="flex-grow: 1;">
        <cargo-ag-grid
          :column-defs="columnDefs"
          :row-data="rowData"
          :grid-options="gridOptions"
          :side-bar="sideBarDefs"
          style="width: 100%;"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="202405282007"
          :total="pageInfo.total"
          :page.sync="pageInfo.pageNum"
          :limit.sync="pageInfo.pageSize"
          @pagination="loadData"
        />
      </div>
    </div>
    <el-dialog
      slot="reference"
      v-el-drag-dialog
      :close-on-click-modal="false"
      class="dialog"
      :visible.sync="showEditDialog"
      :title="title"
      width="400px"
      @closed="cancelHandler"
    >
      <!-- 循环处理 -->
      <el-tabs
        v-model="activeName"
        tab-position="top"
        class="dialog-tabs"
      >
        <el-tab-pane v-for="(item) in form" :label="item.name" :name="item.name">
          <el-form
            :model="item"
            label-width="100px"
            class="dialog-tabs-form"
          >
            <el-form-item :label="$t('SystemMaintenance.ClassifyName')">
              <el-input v-model="item.classifyName" class="required-star" style="width: 200px" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.Sort')">
              <el-input-number v-model="item.sort" :disabled="item.language!=='zh_CN'" class="required-star" controls-position="right" :min="1" :max="999999999" @change="sortSyncHandle(item)" />
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.Remark')">
              <el-input v-model="item.remark" style="width: 200px" type="textarea" />
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer">
        <el-button size="mini " type="primary" @click="submitHandler">{{ $t('common.btn.save') }}</el-button>
        <el-button size="mini " @click="cancelHandler">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import * as classifyMsgApi from '@/api/sysManage/sysMsgConfig/msgClassifyManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import * as LanguageConstant from '@/class/cargo/model/parameters/LanguageConstant'
export default {
  name: 'MsgClassifyManagerView',
  components: {
    cargoAdvanceSelect
  },
  data() {
    return {
      keyword: '',
      columnDefs: [
        {
          headerName: this.$t('SystemMaintenance.ClassifyName'),
          field: 'classifyName',
          width: 250
        }, {
          headerName: this.$t('SystemMaintenance.Sort'),
          field: 'sort'
        }, {
          headerName: this.$t('SystemMaintenance.Remark'),
          field: 'remark',
          width: 250
        }, {
          headerName: this.$t('SystemMaintenance.Language'),
          field: 'language',
          valueFormatter: params => {
            return LanguageConstant.getLanguageByCode(params.value).chineseName
          }
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      originalRowData: [],
      pageInfo: {
        total: 0,
        pageNum: 1,
        pageSize: 20
      },
      gridOptions: {},
      showEditDialog: false,
      title: '',
      activeName: this.$t('Tool.Chinese'),
      tabPosition: 'top',
      form: [
        { code: '', name: this.$t('Tool.Chinese'), language: LanguageConstant.ZH_CN.code, uuid: '', classifyName: '', sort: '', remark: '' },
        { code: '', name: this.$t('Tool.English'), language: LanguageConstant.EN_US.code, uuid: '', classifyName: '', sort: '', remark: '' },
        { code: '', name: this.$t('Tool.Japanese'), language: LanguageConstant.JA_JP.code, uuid: '', classifyName: '', sort: '', remark: '' }
      ]
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    // 初始化加载
    loadData() {
      const loading = getLoading()
      classifyMsgApi.pageClassifyMsg(this.pageInfo).then(resp => {
        if (resp && resp.data.list) {
          // 排序 先排序sort 再排序name
          resp.data.list = resp.data.list.sort((a, b) => {
            if (a.sort < b.sort) return -1
            if (a.sort > b.sort) return 1
            // 如果sort相同，则比较name
            if (a.sort === b.sort) {
              if (a.name < b.name) return -1
              if (a.name > b.name) return 1
              // 如果name也相同，则保持原顺序不变
              return 0
            }
          })
          this.pageInfo.total = Number(resp.data.total)
          this.pageInfo.pageNum = resp.data.pageNum
          this.pageInfo.pageSize = resp.data.pageSize
          this.rowData = resp.data.list
          this.originalRowData = resp.data.list
          this.fastSearchHandle()
        }
      }).finally(() => loading.close())
    },
    // 模糊检索内部数据
    fastSearchHandle() {
      // keyword有内容时
      if (this.keyword) {
        this.rowData = this.rowData.filter(p =>
          (p.classifyName && p.classifyName.toLowerCase().includes(this.keyword.toLowerCase())) ||
          (p.sort && p.sort === this.keyword) ||
          (p.remark && p.remark.toLowerCase().includes(this.keyword.toLowerCase()))
        )
      } else {
        // 没有内容就赋原始值
        this.rowData = this.originalRowData
      }
    },
    // 设置其他语言的排序为中文排序
    sortSyncHandle(obj) {
      // eslint-disable-next-line no-return-assign
      this.form.every(v => v.sort = obj.sort)
    },
    // 新增按钮
    btnAdd() {
      this.title = this.$t('CargoMsg.Cargo_Add')
      this.showEditDialog = true
    },
    // 编辑按钮
    btnEdit() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const selectedRow = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex).data : null
      if (!selectedRow) {
        this.$message.warning(this.$t('Message.PleaseSelectDataBeforeOperation'))
        return
      }
      // 选择数据后将对应的数据绑定到form中
      const filter = this.rowData.filter(v => v.code === selectedRow.code)
      // 处理选中后的优选显示标签
      this.activeName = selectedRow.language === LanguageConstant.ZH_CN.code ? this.$t('Tool.Chinese') : selectedRow.language === LanguageConstant.EN_US.code ? this.$t('Tool.English') : selectedRow.language === LanguageConstant.JA_JP.code ? this.$t('Tool.Japanese') : ''
      filter.forEach(v => {
        const formData = this.form.find(val => val.language === v.language)
        if (formData) {
          // 这里我们复制除了code以外的所有属性
          Object.keys(formData).forEach(key => {
            if (key !== 'language' && key !== 'name') {
              formData[key] = v[key]
            }
          })
        }
      })
      this.title = this.$t('CargoMsg.Cargo_Edit')
      this.showEditDialog = true
    },
    // 删除按钮处理
    btnRemoveHandler() {
      const cell = this.gridOptions.api.getFocusedCell()
      const nodes = this.gridOptions.api.rowModel.rowsToDisplay
      const node = (cell && nodes.length > 0) ? nodes.find(node => node.rowIndex === cell.rowIndex) : null
      if (!node || !node.data) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectDataToDelete'))
        return
      }
      this.$confirm(this.$t('SystemMaintenance.ConfirmDeletionOfClassifyMsg'), this.$t('common.tips.confirm'), {
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const loading = getLoading()
        // 当分类下有配置的消息时，提示不可以删除
        classifyMsgApi.checkClassifyMsg(node.data.code).then(resp => {
          if (resp.data) {
            this.$message.warning(this.$t('SystemMaintenance.ClassifyMsgDeletedTips'))
            return
          }
          // 调用删除接口
          classifyMsgApi.removeClassifyMsg([node.data.code]).then(resp => {
            const res = resp.data
            if (res > 0) {
              this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
              this.loadData()
            } else {
              this.$message.warning(this.$t('SeaExport.OperationFailed'))
            }
          }).finally(() => loading.close())
        }).finally(() => loading.close())
      })
    },
    submitHandler() {
      if (this.title === this.$t('CargoMsg.Cargo_Edit')) {
        this.updateHandle()
      } else if (this.title === this.$t('CargoMsg.Cargo_Add')) {
        this.addHandle()
      }
    },
    cancelHandler() {
      this.showEditDialog = false
      this.form = [
        { code: '', name: this.$t('Tool.Chinese'), language: LanguageConstant.ZH_CN.code, uuid: '', classifyName: '', sort: '', remark: '' },
        { code: '', name: this.$t('Tool.English'), language: LanguageConstant.EN_US.code, uuid: '', classifyName: '', sort: '', remark: '' },
        { code: '', name: this.$t('Tool.Japanese'), language: LanguageConstant.JA_JP.code, uuid: '', classifyName: '', sort: '', remark: '' }
      ]
      this.activeName = this.$t('Tool.Chinese')
    },
    checkPramHandle() {
      // 修改时uuid不可为空
      if (this.title === this.$t('CargoMsg.Cargo_Edit') && this.form.some(v => !v.uuid)) {
        return false
      }
      // 分类消息不可为空
      if (this.form.some(v => !v.classifyName)) {
        this.$message.warning(this.$t('SystemMaintenance.ClassifyMsgNameEmpty'))
        return false
      }
      // 排序不可为空
      if (this.form.some(v => !v.sort)) {
        this.$message.warning(this.$t('SystemMaintenance.ClassifyMsgSortEmpty'))
        return false
      }
      if (this.form.some(v => v.sort > 999999999)) {
        this.$message.warning(this.$t('SystemMaintenance.LengthExceedsAllowableLength'))
        return false
      }
      return true
    },
    // 填充其他语言的信息
    fillDefaultInfo() {
      // 找到中文的信息
      const zhCnInfo = this.form.find(v => v.language === LanguageConstant.ZH_CN.code)
      // 英文或者日文内容为空 就填充中文的信息
      this.form.forEach(v => {
        if (v.language !== LanguageConstant.ZH_CN.code) {
          // v的属性为空就赋值为zhCnInfo的属性
          for (const key in v) {
            if (key !== 'language' || key !== 'name') {
              v[key] = v[key] || zhCnInfo[key]
            }
          }
        }
      })
    },
    // 新增
    addHandle() {
      // 校验数据
      if (!this.checkPramHandle()) {
        return
      }
      // 调用新增接口
      const loading = getLoading()
      classifyMsgApi.addClassifyMsg(this.form).then(resp => {
        if (resp && resp.data && resp.data > 0) {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
          this.cancelHandler()
          this.loadData()
        } else {
          this.$message.warning(this.$t('SeaExport.OperationFailed'))
        }
      }).finally(() => loading.close())
    },
    // 修改
    updateHandle() {
      // 校验数据
      if (!this.checkPramHandle()) {
        return
      }
      // 调用修改接口
      const loading = getLoading()
      classifyMsgApi.updateClassifyMsg(this.form).then(resp => {
        if (resp && resp.data && resp.data > 0) {
          this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
          this.cancelHandler()
          this.loadData()
        } else {
          this.$message.warning(this.$t('SeaExport.OperationFailed'))
        }
      }).finally(() => loading.close())
    }
  }
}
</script>

<style lang="scss" scoped>
.msg-classify-manager-view {
  .required-star {
    position: relative;

    &::after {
      content: "*";
      color: red;
      font-size: 20px;
      position: absolute;
      top: 65%;
      right: -15px;
      transform: translateY(-50%);
    }
  }
}
</style>
<style lang="scss">
 .msg-classify-manager-view {
   .el-tabs__active-bar {
     display: none !important;
   }
   .el-tabs__nav-wrap::after{
     height: 1px;
    }

   .dialog-tabs {
     height: 200px;

     .dialog-tabs-form {
       margin-top: 20px;
     }

     .el-tabs__item {
       margin-left: 0 !important;
       background-color: #F3F4F5 !important;
       border-radius: 0 !important;
     }
     .el-tabs__item.is-active {
       background-color: #3A73CE !important;
     }
   }
 }
</style>
